import { InjectionToken } from '@angular/core';

export enum EntityStoreKey {
  featureFlags = 'featureFlags',
}

export type FeatureFlagsMap = Record<FeatureFlag, boolean>;
export const FEATURE_FLAGS = new InjectionToken<FeatureFlagsMap>('Feature flags map');

export enum FeatureFlag {
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  NewCareers = 'new_careers',
  EventDebug = 'debug_event_tracking',
  Requisitions = 'requisitions_flag',
  Hotjar = 'hotjar',
  Texting = 'texting',
  ScreeningQuestionDate = 'screening_question_date',
  SharedMailbox = 'shared_mailbox',
  CoverLetterFile = 'cover_letter_file',
  ManualSlots = 'manual_slots',
  SharedEvaluations = 'shared_evaluations',
  RenewalDowngrade = 'renewal_downgrade',
}
